module.exports = __webpack_public_path__ + "img/135x90-03.c332ec59.png";